(() => {
  const SELECTOR = '[data-ers-hero]';

  class ErsHero {
    constructor(section) {
      this.section = section;
      this.video = section.querySelector('video');
      this.button = section.querySelector('[data-ers-hero-play]');

      if (!this.video || !this.button) return;

      this.playLabel = this.button.dataset.playLabel || 'Play';
      this.pauseLabel = this.button.dataset.pauseLabel || 'Pause';
      this.button.addEventListener('click', this.onToggle.bind(this));
      this.syncState();

      this.video.addEventListener('play', this.syncState.bind(this));
      this.video.addEventListener('pause', this.syncState.bind(this));
    }

    onToggle() {
      if (this.video.paused) {
        const playPromise = this.video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      } else {
        this.video.pause();
      }
    }

    syncState() {
      const isPlaying = !this.video.paused;
      const label = isPlaying ? this.pauseLabel : this.playLabel;
      const text = this.button.querySelector('.ers-hero__play-text');

      this.button.setAttribute('aria-label', label);
      if (text) text.textContent = label;
    }
  }

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((section) => {
      if (section.dataset.ersHeroInitialized === 'true') return;
      section.dataset.ersHeroInitialized = 'true';
      new ErsHero(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
